export const COLORS = {
    primary_blue: "#00a0e4",
};

export const PHONE_NUMBER = "0903580818";
export const EMAIL = "sieuthidienlanh.vn@gmail.com"